<template>
    <v-app>
      <v-content>
        <v-container fluid>
          <v-layout align-center justify-center>
            <v-card style="width: 500px">
              <v-responsive :aspect-ratio="16 / 9">
                <v-card-title primary-title>
                  <div>
                    <div class="headline pl-2 pa-1">{{ $t("customers.createRestaurantN.heading") }}</div>
                  </div>
                </v-card-title>
                <v-form ref="form" v-model="form" class="pa-4 pt-6">
                  <v-flex>
                    <v-text-field
                      outline
                      v-model="model.name"
                      :rules="[rules.required]"
                      :label="$t('customers.createRestaurantN.restaurantName')"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-autocomplete
                      v-model="returnObject"
                      clearable
                      :items="addresses"
                      :loading="isLoading"
                      :search-input.sync="search"
                      outline
                      dense
                      :label="$t('customers.createRestaurantN.address')"
                      item-text="text"
                      item-value="text"
                      :placeholder="$t('customers.createRestaurantN.addressPlaceholder')"
                      :rules="[rules.required]"
                      no-filter
                      return-object
                    >
                      <template slot="item" slot-scope="addresses">
                        <v-list-tile-content>
                          <v-list-tile-title
                            v-html="addresses.item.text"
                          ></v-list-tile-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-btn
                    :loading="loading"
                    block
                    @click="createRestaurant"
                    color="secondary"
                    dark
                    >{{ $t("common.create") }}</v-btn
                  >
                </v-form>
              </v-responsive>
            </v-card>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    title() {
      return this.$t("customers.createRestaurantN.title");
    },
    data: () => ({
      address: "",
      addresses: [],
      returnObject: "",
      results: [],
      allResults: [],
      isLoading: false,
      search: null,
      loading: false,
      error: false,
      model: {
        name: "",
        address: "",
        pickup_location: {
          type: "Point",
          coordinates: [],
        },
        passenger_type: "RESTAURANT",
        landmark: "",
      },
      email: undefined,
      form: false,
      isLoading: false,
      password: undefined,
    }),
    computed: {
      rules() {
        return {
          length: (len) => (v) =>
            (v || "").length >= len || this.$t("customers.createRestaurantN.invalidLength", { length: len }),
          required: (v) => !!v || this.$t("customers.createRestaurantN.requiredField"),
        };
      },
    },
  
    watch: {
      search(val) {
        this.isLoading = true;
        const params = new URLSearchParams(this.initialSearchParams);
        params.append("address", val);
        this.axios
          .get("address", { params })
          .then((res) => {
            this.addresses = res.data.data.map((item) => ({
              text:
                `${item.name || ""}` +
                " " +
                `${item.street_name || ""}` +
                " " +
                `${item.street_number || ""}`,
              ...item,
            }));
          })
          .catch((err) => console.log(err))
          .finally(() => (this.isLoading = false));
      },
    },
  
    methods: {
      createRestaurant() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          var ret = this.returnObject.text.replace("null ", "");
          this.model.address = ret;
          if (this.returnObject.name)
            this.model.landmark = this.returnObject.name;
          else if (this.returnObject.street_name)
            this.model.landmark = this.returnObject.street_name;
  
          this.model.pickup_location.coordinates.push(
            this.returnObject.centroid.coordinates[0]
          );
          this.model.pickup_location.coordinates.push(
            this.returnObject.centroid.coordinates[1]
          );
  
          this.axios
            .post(this.api.ACTIONS.RESTAURANT, {
              ...this.model,
              provider: "users",
            })
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("customers.createRestaurantN.restaurantCreated"), "green");
              this.$router.push("/restaurants");
            })
            .catch((err) => {
              console.log(err.message);
              this.error = true;
              let response = err.response;
              if (response) {
                window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
                console.log(response.data);
              } else {
                window.getApp.$emit("SHOW_TOAST", this.$t("customers.createRestaurantN.checkInfo"), "red");
              }
            })
            .then(() => (this.loading = false));
        }
        console.log(this.model);
        // }
      },
    },
  };
  </script>
  